/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Ledger_Col_BalanceInputs */

const vi_customer_debt_ledger_col_balance = /** @type {(inputs: Customer_Debt_Ledger_Col_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dư nợ luỹ kế`)
};

/**

* @param {Customer_Debt_Ledger_Col_BalanceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_ledger_col_balance = /** @type {((inputs?: Customer_Debt_Ledger_Col_BalanceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Ledger_Col_BalanceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_ledger_col_balance(inputs)
});